export default "__VITE_ASSET__CaNi9caI__"